import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { Description as DocumentIcon } from '@mui/icons-material';
import { DocumentListItem } from '../../../../../types';

interface SummaryCardProps {
  documents: DocumentListItem[];
}

const SummaryCard: React.FC<SummaryCardProps> = ({ documents }) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <DocumentIcon color="primary" sx={{ fontSize: 40 }} />
          <Box>
            <Typography variant="h4">{documents.length}</Typography>
            <Typography variant="body2" color="text.secondary">
              Documents
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
